// extracted by mini-css-extract-plugin
export default {"wrapper":"sliders_wrapper__Lq+cV","content":"sliders_content__Ve2+K","title":"sliders_title__w6SHE"};